import React, { useEffect, useState } from "react";
import { getBlobData } from "../../axios/axiosHelper";

const ProtectedProfileImage = ({
  type,
  accountId,
  available,
  name,
  imageLabel,
  className = ""
}) => {
  const [url, setUrl] = useState("");
  const fallback = String(name || "?").trim().charAt(0) || "?";

  useEffect(() => {
    let active = true;
    let objectUrl = "";
    setUrl("");
    if (!available || !accountId) return () => { active = false; };
    getBlobData(
      `/admin/registration-reviews/${type}/${accountId}/documents/profileImage`,
      true
    )
      .then((response) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(response.data);
        setUrl(objectUrl);
      })
      .catch(() => {
        if (active) setUrl("");
      });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [accountId, available, type]);

  return (
    <span className={className}>
      {url ? <img src={url} alt={`${name} ${imageLabel}`} /> : fallback}
    </span>
  );
};

export default ProtectedProfileImage;
